export default {
  alerts: {
    info: [],
    success: [],
    warning: [],
    error: [],
  },
  auth: {
    token: {},
    user: {},
    role: {},
    permissions: [],
    redirects: {
      index: '/',
      unauthenticated: '/login',
      authenticated: '/threads',
    },
    sourceRoute: {},
  },
  siteMessages: {
    activeItem: {},
    items: [],
    itemsMeta: {},
    statuses: [],
    presentableItems: [],
  },
  billing: {
    activeItem: {},
    items: [],
    itemsMeta: {},
    conflicts: [],
    conflictsMeta: {},
  },
  businesses: {
    activeItem: {
      settings: {},
      billingAccounts: [],
      billingCountriesByStatus: [],
      labels: [],
      comments: [],
      campaigns: [],
      threadSubmissions: [],
      enabledPromotions: [],
      threadSubmissionLimits: [],
      notifications: [],
      keyAccounts: [],
      accountManagers: [],
      businessAdvertisers: [],
      billingAccountAdvertisers: [],
      businessMerchants: [],
      businessCpmPrices: [],
      businessFreeImpressions: [],
      businessPlacements: [],
      notes: [],
    },
    items: [],
    itemsMeta: {},
    statuses: [],
    notificationTypes: [],
    enabledCountries: [],
  },
  businessUsers: {
    items: [],
    itemsMeta: {},
    limits: [],
    enabledPromoCountries: [],
    submissionLimits: {},
    settings: {},
    statuses: [],
  },
  cannedReplies: {
    activeItem: {},
    items: [],
    itemsMeta: {},
  },
  config: {
    languages: [],
    timezones: [],
    countries: [],
    euCountries: [],
    colors: [],
    notificationAssignments: [],
    notificationAccountTypes: [],
  },
  contracts: {
    activeItem: {
      prices: [],
    },
    contractTypes: [],
    domains: [],
    items: [],
    itemsMeta: {},
    expiringItems: [],
    expiringItemsMeta: {},
    statuses: [],
    paymentTypes: [],
  },
  creatorProgram: {
    activeBillingAccount: {},
    activeBusiness: {},
    businesses: [],
    businessesMeta: {},
    billingAccounts: [],
    billingAccountsMeta: {},
  },
  events: {
    assets: [],
    assetsMeta: {},
    activeAsset: {},
    assetsColours: [],
    assetsImageTypes: [],
    promotions: [],
    promotionsMeta: {},
    activePromotion: {},
    promotionsStatuses: [],
    promotionsPlacements: [],
    promotionsTypes: [],
  },
  labels: {
    activeItem: {},
    items: [],
    itemsMeta: {},
    systemItems: [],
    systemItemsMeta: {},
  },
  locale: {
    language: 'en',
  },
  networks: {
    items: [],
    itemsMeta: {},
    statuses: [],
    linkedCountries: [],
  },
  packages: {
    activeItem: {
      labels: [],
      packageSubmissionLimits: [],
      queues: [],
    },
    items: [],
    itemsMeta: {},
    queueTypes: [],
  },
  payments: {
    activeItem: {},
    items: [],
    itemsMeta: {},
    statuses: [],
  },
  pepper: {
    merchants: [],
    groups: [],
    events: [],
  },
  pins: {
    activeItem: {},
    items: [],
    itemsMeta: {},
    platforms: [],
    visibilities: [],
    pages: [],
    pageObjects: [],
  },
  promotions: {
    activeItem: {},
    items: [],
    itemsMeta: {},
    activeLineItem: {},
    advertisers: [],
    advertisersMeta: {},
    statuses: [],
    orderStatuses: [],
    lineStatuses: [],
    types: [],
    costTypes: [],
    placements: [],
    geo: [],
    devices: [],
    targetGroups: [],
    targetUsers: [],
    freqTimeUnits: [],
    threads: [],
    businessMerchants: [],
    forecast: [],
    accountTypes: [],
    contractNames: [],
    orderTypes: [],
  },
  reports: {
    daily: {
      items: [],
      meta: {},
    },
    dailyCpm: {
      items: [],
      meta: {},
    },
    advancedDaily: {
      items: [],
      meta: {},
    },
    monthly: [],
    accounts: [],
    contracts: [],
    advancedContracts: [],

    engagements: [],
    engagementsSingle: [],
    deal: [],
    deals: [],
    dealsMeta: {},
    topDeals: [],
    chartSummary: [],
    chartSummarySingle: [],
    statuses: [],
    submissionTypes: [],
  },
  sponsorships: {
    items: [],
    itemsMeta: {},
    statuses: [],
  },
  schedules: {
    threads: [],
    threadsMeta: [],
  },
  settings: {
    limits: [],
  },
  theme: {
    mode: 'light',
  },
  threads: {
    activeItem: {
      pendingComment: '',
      labels: [],
      merchants: [],
      comments: [],
      duplicates: [],
      log: {
        items: [],
        meta: {},
      },
      hasUpdatedStatus: false,
    },
    items: [],
    itemsMeta: {},
    priorities: [],
    archived: {
      items: [],
      meta: {},
    },
    statuses: [],
    filterStatuses: [],
    categories: [],
    accountTypes: [],
    submissionStatuses: [],
    commentPermissions: [],
    priceComparison: [],
    discountTypes: [],
    queues: [],
    isDirtyDeal: false,
    isDirtyCampaign: false,
  },
  tracking: {
    activeAdvertiser: {},
    activeProgram: {},
    advertiserDomains: [],
    advertiserPrograms: [],
    advertiserProgramsMeta: {},
    advertisers: [],
    advertisersMeta: {},
    programStatuses: [],
    activeTrafficNetwork: {},
    networkCredentials: [],
    trafficNetworks: [],
    trafficNetworkTypes: [],
    comboTypes: [],
    programTags: [],
  },
  users: {
    activeItem: {
      settings: {},
      notifications: [],
    },
    items: [],
    itemsMeta: {},
    internalItems: [],
    internalItemsMeta: {},
    pendingItems: [],
    pendingItemsMeta: {},
    roles: [],
    countries: [],
    statuses: [],
    managers: [],
    notificationTypes: [],
    assignable: [],
    assignmentTypes: [],
    subRoles: [],
  },
};
